import styled from 'styled-components'
import { H2, Regular } from 'components/Typography'
import theme from 'theme_'
import { WhiteBlock } from 'components/Layout'

export const HomeSubscriptionHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: space-between;
`

export const HistoryMobileHeader = styled(H2)`
  margin-top: 16px;
  margin-bottom: 16px;
`

export const EmptyHistoryContainer = styled(WhiteBlock)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 28px;
  padding: 40px;
  background-color: ${theme.colors.white};
`

export const EmptyHistoryBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  max-width: 600px;
`

export const EmptyHistoryTitle = styled(H2)`
  text-align: center;
  color: ${theme.colors.duneWarmGrey};
`

export const EmptyHistoryDescription = styled(Regular)`
  text-align: center;
  color: ${theme.colors.moreGrey};
`
